import { render, staticRenderFns } from "./statement_get.vue?vue&type=template&id=fec89460&scoped=true&"
import script from "./statement_get.vue?vue&type=script&lang=js&"
export * from "./statement_get.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec89460",
  null
  
)

export default component.exports